<template>
  <div v-if="insurance_data">
    <v-card id="edit">
      <v-container fluid>
        <p class="headline">修改保單資料</p>
        <v-form ref="form" lazy-validation>
          <v-row class="mb-2">
            <!-- mb-2是下邊界 -->
            <v-col :lg="4">
              <agency-combo
                v-model="insurance_data.agency_company"
                label="代理商"
                :rules="[
                  (v) =>
                    !(v === null || v.name == '') || '請選擇/輸入代理商名稱',
                ]"
              >
              </agency-combo>
            </v-col>

            <v-col :lg="4">
              <salesman-combo
                v-model="insurance_data.salesman"
                label="業務員姓名"
                :rules="[
                  (v) =>
                    !(v === null || v.name.trim() == '') || '請填寫業務員名稱',
                ]"
              >
              </salesman-combo>
            </v-col>
          </v-row>
          <v-row>
            <v-col :lg="4">
              <insurance-company-combo
                v-model="insuranceCompany"
                :items="this.insuranceCompanies"
                label="保險公司"
                :rules="[
                  (v) =>
                    !(v === null || v.name.trim() == '') ||
                    '請選擇/輸入保險公司名稱',
                ]"
              >
              </insurance-company-combo>
            </v-col>
            <v-col :lg="4">
              <v-combobox
                v-model="insuranceProduct"
                label="保險商品名稱"
                :rules="[
                  (v) =>
                    !(v === null || v.name.trim() == '') ||
                    '請選擇/輸入保險商品名稱',
                ]"
                :items="insuranceProducts"
                item-text="name"
                required
                clearable
              ></v-combobox>
            </v-col>
            <v-col :lg="4">
              <v-text-field
                v-model="insurance_data.insurance_number"
                :rules="[(v) => !!v || '請填寫保單號碼']"
                label="保單號碼"
                readonly
                filled
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col :lg="4">
              <holder-combo
                v-model="holder"
                :items="holders"
                label="投保人姓名"
                :rules="[
                  (v) =>
                    !(v === null || v.name == '') || '請選擇/輸入投保人姓名',
                ]"
              >
              </holder-combo>
            </v-col>
            <v-col :lg="4">
              <v-menu
                v-model="holder_birthday_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="insurance_data.holder.birthday"
                    :rules="[(v) => !!v || '請填寫出生日期']"
                    label="出生日期"
                    prepend-icon="mdi-calendar"
                    :disabled="disableHolder"
                    v-bind="attrs"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="insurance_data.holder.birthday"
                  @input="holder_birthday_menu = false"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col :lg="4">
              <v-radio-group
                v-model="insurance_data.holder.sex"
                row
                label="性別"
                :disabled="disableHolder"
                :rules="[(v) => !!v || '請填寫性別']"
              >
                <v-radio label="男性" value="male"></v-radio>
                <v-radio label="女性" value="female"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col :lg="4">
              <city-autocomplete
                @changeVal="handleCityChange"
                label="城市"
                v-model="city"
                :disabled="disableHolder"
                :rules="[
                  (v) =>
                    !(v === null || v.name === null || v.name.trim() == '') ||
                    '請填寫縣市',
                ]"
              ></city-autocomplete>
            </v-col>
            <v-col :lg="4">
              <v-autocomplete
                label="區域/鄉鎮"
                v-model="township"
                :items="areas"
                item-text="name"
                :disabled="disableHolder"
                :rules="[
                  (v) =>
                    !(v === null || v.name === null || v.name.trim() == '') ||
                    '請填寫區域/鄉鎮',
                ]"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col :lg="4">
              <v-text-field
                v-model="insurance_data.holder.address"
                :rules="[(v) => !!v || '請填寫詳細地址']"
                label="詳細地址"
                :disabled="disableHolder"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col :lg="4">
              <v-text-field
                v-model="insurance_data.contribution_period"
                :rules="[(v) => !!v || '請填寫供款年期']"
                label="供款年期"
                required
              ></v-text-field>
            </v-col>
            <v-col :lg="4">
              <v-text-field
                v-model="insurance_data.period_fee"
                :rules="[(v) => !!v || '請填寫每期保費']"
                label="每期保費"
                required
              ></v-text-field>
            </v-col>
            <v-col :lg="4">
              <v-select
                v-model="insurance_data.currency_type"
                :items="currency_items"
                :rules="[(v) => !!v || '請選擇幣別']"
                label="幣別"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col :lg="3">
              <v-text-field
                v-model="insurance_data.beneficiary_name"
                :rules="[(v) => !!v || '請填寫受益人姓名']"
                label="受益人姓名"
                required
              ></v-text-field>
            </v-col>
            <v-col :lg="3">
              <v-text-field
                v-model="insurance_data.second_holder_name"
                label="後備/第二持有人姓名"
              ></v-text-field>
            </v-col>
            <v-col :lg="3">
              <v-text-field
                v-model="insurance_data.backup_holder_name"
                label="後備/第二受保人姓名"
              ></v-text-field>
            </v-col>
            <v-col :lg="3">
              <v-text-field
                v-model="insurance_data.loss_of_mobility"
                label="失去行動能力權益人士"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col :lg="4">
              <v-menu
                v-model="insured_date_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="insurance_data.insured_date"
                    label="投保日期"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="insurance_data.insured_date"
                  @input="insured_date_menu = false"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col :lg="4">
              <v-menu
                v-model="effective_date_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="insurance_data.effective_date"
                    label="供款期滿日期"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="insurance_data.effective_date"
                  @input="effective_date_menu = false"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col :lg="4">
              <v-text-field
                v-model="insurance_data.insured_name"
                :rules="[(v) => !!v || '請填寫被保險人姓名']"
                label="被保險人姓名"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="insurance_data.remarks"
                label="備註"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn color="error" small class="mr-2" @click="openDeleteDialog">
            刪除
          </v-btn>
          <v-btn
            color="success"
            small
            class="mr-2"
            @click="updateInsuranceData"
          >
            更新
          </v-btn>
          <v-btn color="primary" small @click="toList"> 回列表 </v-btn>
        </v-form>
        <p class="mt-3">{{ message }}</p>
        <v-dialog v-model="saveDialog" max-width="400">
          <div v-if="onSaving">
            <v-card max-width="400">
              <v-card-title>存檔中請稍候</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-progress-circular
                  :size="70"
                  indeterminate
                  class="primary--text"
                />
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </div>
          <div v-else>
            <v-card max-width="400">
              <v-card-title>存檔已完成</v-card-title>
              <v-card-text>請問您接下來想要做什麼？</v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mr-2" @click="saveDialog = false"
                  >繼續修改</v-btn
                >
                <v-btn color="success" class="mr-2" @click="toNew"
                  >新增資料</v-btn
                >
                <v-btn color="primary" class="mr-2" @click="toList"
                  >返回列表</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </div>
        </v-dialog>
        <v-dialog v-model="deleteDialog" max-width="400px">
          <v-card max-width="400" color="red lighten-2" dark>
            <v-card-title class="headline">保單資料刪除</v-card-title>
            <v-card-subtitle>您確認要刪除此筆資料嗎？</v-card-subtitle>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="white" text outlined @click="closeDeleteDialog"
                >取消</v-btn
              >
              <v-btn
                color="white"
                light
                class="error--text"
                :disabled="deleteLoading"
                @click="deleteInsuranceData"
              >
                <div v-show="!deleteLoading">確定</div>
                <div v-show="deleteLoading">
                  <v-progress-circular
                    size="25"
                    indeterminate
                  ></v-progress-circular>
                </div>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
  </div>
  <div v-else>
    <p>請檢查保單資料...</p>
  </div>
</template>

<script>
import CommonDataService from "../../services/CommonDataService";
import InsuranceDataService from "../../services/InsuranceDataService";
import citydata from "@/services/citiesdata.json";

import CityAutocomplete from "../../components/CityAutocomplete";
import SalesmanCombo from "../../components/SalesmanCombo";
import HolderCombo from "../../components/HolderCombo";
import AgencyCombo from "../../components/AgencyCombo";
import InsuranceCompanyCombo from "../../components/InsuranceCompanyCombo";

import ComboBoxUtil from "../../utils/ComboBoxUtil";

export default {
  name: "insurancedata-detail",
  components: {
    CityAutocomplete,
    SalesmanCombo,
    InsuranceCompanyCombo,
    HolderCombo,
    AgencyCombo,
  },
  data() {
    return {
      insurance_data: null,
      currency_items: ["USD", "RMB", "HKD", "AUD", "CAD", "EUR"], //幣別選項
      message: "",
      insured_date_menu: false,
      effective_date_menu: false,
      holder_birthday_menu: false,
      city: { name: null, areas: [] }, //v-model for 城市
      township: { name: null, zip: null }, //v-model for 區域
      cityItemIdx: -1,
      insuranceCompanies: [], //從API取的的保險公司＋商品資料，要注入至保險公司元件
      insuranceCompany: { id: -1, name: "", insurance_products: [] }, //v-model for 保險公司
      insuranceProduct: { id: -1, name: "" }, //v-model for 保險商品
      isInsuranceCompanyChanged: false, //這個變數用來處理getInsuranceData與watch insuranceCompany造成insuranceProduct的資料清空衝突。
      holders: [], //從API取的投保人資料，要注入至投保人元件
      holder: {
        id: -1,
        name: "",
        birthday: "",
        sex: "",
        city: "",
        township: "",
        address: "",
        displaytext: "",
      }, //v-model for 投保人
      isHolderChanged: false, //用來處理變更投保人
      saveDialog: false, //儲存對話框
      onSaving: false, //對話內容切換
      deleteDialog: false, //刪除對話框
      deleteLoading: false,
      isDataChanged: false,
    };
  },
  created() {
    this.isInsuranceCompanyChanged = true;
    this.message = "";
    this.findInsuranceCompanies();
    this.findHolders();
    this.getInsuranceData(this.$route.params.id);
  },
  computed: {
    areas() {
      //console.log('computed.areas, this.city.areas=')
      //console.log(this.city.areas)
      return this.city.areas;
    },
    insuranceProducts() {
      if (this.insuranceCompany === null) {
        return [];
      }
      return this.insuranceCompany.insurance_products;
    },
    disableHolder() {
      return this.holder.id >= 0;
    },
  },
  watch: {
    insuranceCompany: function () {
      /*
            console.log('watch-insuranceCompany, val=')
            console.log(val)
            console.log('watch-insuranceCompany, prev=')
            console.log(prev)
            console.log('watch-insuranceCompany, insuranceCompany=')
            console.log(this.insuranceCompany)
            console.log('watch-insuranceCompany, (val === prev) = ')
            console.log((val === prev))
            */
      if (this.insuranceCompany === null) {
        this.insurance_data.insurance_company.id = -1;
        this.insurance_data.insurance_company.name = "";
      } else {
        this.insurance_data.insurance_company.id =
          this.insuranceCompany.id === null ? -1 : this.insuranceCompany.id;
        this.insurance_data.insurance_company.name =
          this.insuranceCompany.name === null ? "" : this.insuranceCompany.name;
      }
      //console.log('watch-insuranceCompany, this.isInsuranceCompanyChanged =')
      //console.log(this.isInsuranceCompanyChanged == true)
      if (this.isInsuranceCompanyChanged == true) {
        //因為在取得資料時，已經先設定了insuranceProduct, 然後才觸發watch，因此要在這裡取巧先跳過
        this.isInsuranceCompanyChanged = false;
      } else {
        this.insuranceProduct = { id: -1, name: "" };
      }
    },
    insuranceProduct(val) {
      /*
            console.log('watch-insuranceProduct, val=')
            console.log(val)
            console.log('watch-insuranceProduct, prev=')
            console.log(prev)
            console.log('watch-insuranceProduct, insuranceProduct=')
            console.log(this.insuranceProduct)
            console.log('watch-insuranceProduct, (val === prev) = ')
            console.log((val === prev))
            */
      this.insuranceProduct = ComboBoxUtil.getComboBoxModel(
        val,
        this.insuranceProducts,
        { id: -1, name: "" }
      );
      if (this.insuranceProduct != null) {
        this.insurance_data.insurance_product.id = this.insuranceProduct.id;
        this.insurance_data.insurance_product.name = this.insuranceProduct.name;
      }
    },
    holder(val) {
      //console.log('watch-val=')
      //console.log(val)
      this.holder = ComboBoxUtil.getComboBoxModel(val, this.holders, {
        id: -1,
        name: "",
        birthday: "",
        sex: "",
        city: "",
        township: "",
        address: "",
        displaytext: "",
      });
      if (this.holder.displaytext == "")
        this.holder.displaytext = this.holder.name;

      //console.log('watch-holder=')
      //console.log(this.holder)
      this.insurance_data.holder.id = this.holder.id;
      this.insurance_data.holder.name = this.holder.name;
      //console.log('watch-holder, this.holder.birthday=')
      //console.log(this.holder.birthday)

      this.insurance_data.holder.birthday = this.holder.birthday;

      //console.log('watch-holder, this.insurance_data.holder.birthday=')
      //console.log(this.insurance_data.holder.birthday)
      //console.log('watch-holder, this.insurance_data.holder=')
      //console.log(this.insurance_data.holder)

      this.insurance_data.holder.sex =
        this.holder.sex != ""
          ? this.holder.sex
          : this.insurance_data.holder.sex;
      this.insurance_data.holder.address =
        this.holder.address != ""
          ? this.holder.address
          : this.insurance_data.holder.address;

      if (this.holder.city != "") {
        this.city = this.getCity(this.holder.city);
      }
      if (this.holder.township != "") {
        let filter = (element) => element.name === this.holder.township;
        this.townshipIdx = this.city.areas.findIndex(filter);
        this.township = this.city.areas[this.townshipIdx];
      }

      if (this.isDataChanged == true) {
        this.isDataChanged = false;
      } else {
        this.insurance_data.insured_name = this.holder.name;
      }

      console.log("watch-holder, this.insurance_data=");
      console.log(this.insurance_data);

      this.isHolderChanged = true;
    },
    township: function () {
      //console.log('watch-township: township=')
      //console.log(this.township)
      if (this.township == undefined || this.township.name === null) {
        this.insurance_data.holder.township = "";
        this.insurance_data.holder.zipcode = "";
      } else {
        var itemName = "";
        if (typeof this.township === "string") {
          itemName = this.township;
        } else {
          itemName = this.township.name;
        }
        let filter = (element) => element.name === itemName;
        this.townshipIdx = this.city.areas.findIndex(filter);

        //console.log('watch-township: townshipIdx=' + this.townshipIdx)
        this.township = this.city.areas[this.townshipIdx];

        this.insurance_data.holder.township = this.township.name;
        this.insurance_data.holder.zipcode = this.township.zip;
      }
    },
  },
  methods: {
    getCity(name) {
      let filter = (element) => element.name === name;
      let idx = citydata.findIndex(filter);
      return citydata[idx];
    },
    async findInsuranceCompanies() {
      //改成非同步，避免資料還沒有回來時就出錯
      try {
        const response = await CommonDataService.findInsuranceCompanies();

        this.insuranceCompanies = response.list;
      } catch (error) {
        console.error(error);
      }
    },

    async findHolders() {
      //改成非同步，避免資料還沒有回來時就出錯
      try {
        const response = await CommonDataService.findHolders();

        this.holders = response.list;
      } catch (error) {
        console.error(error);
      }
    },

    async getInsuranceData(id) {
      //改成非同步，避免資料還沒有回來時就出錯
      try {
        const response = await InsuranceDataService.get(id);

        this.insurance_data = response.item;
        //console.log(JSON.stringify(response.data));
        this.message = response.message;

        //ViewModel Mapping
        this.city = this.getCity(this.insurance_data.holder.city);

        let townshipFilter = (element) =>
          element.name === this.insurance_data.holder.township;
        let townshipIdx = this.city.areas.findIndex(townshipFilter);
        this.township = this.city.areas[townshipIdx];

        //利用id找陣列的index，再取值
        let insuranceCompanyIdx = this.insuranceCompanies.findIndex(
          (element) => element.id === this.insurance_data.insurance_company.id
        );
        this.insuranceCompany = this.insuranceCompanies[insuranceCompanyIdx];
        //console.log('this.insuranceCompany =')
        //console.log(this.insuranceCompany)

        let insuranceProductIdx =
          this.insuranceCompany.insurance_products.findIndex(
            (element) => element.id === this.insurance_data.insurance_product.id
          );
        this.insuranceProduct =
          this.insuranceCompany.insurance_products[insuranceProductIdx];
        //console.log('this.insuranceProduct =')
        //console.log(this.insuranceProduct)

        let holderIdx = this.holders.findIndex(
          (element) => element.id === this.insurance_data.holder.id
        );
        this.holder = this.holders[holderIdx];
        //如果找不到資料，直接填入對應資料
        if (this.holder === undefined) {
          this.holder = {
            id: this.insurance_data.holder.id,
            name: this.insurance_data.holder.name,
            birthday: this.insurance_data.holder.birthday,
            sex: this.insurance_data.holder.sex,
            city: this.insurance_data.holder.city,
            township: this.insurance_data.holder.township,
            address: this.insurance_data.holder.address,
            displaytext:
              this.insurance_data.holder.name +
              "(" +
              this.insurance_data.holder.birthday +
              ")",
          };
        }

        this.isDataChanged = true;
      } catch (error) {
        console.error(error);
      }
    },

    updateInsuranceData() {
      if (this.$refs.form.validate()) {
        //檢查欄位
        this.saveDialog = true;
        this.onSaving = true;
        var updateData = { insurance_data: this.insurance_data };
        //console.log('updateInsuranceData, updateData=')
        //console.log(updateData)
        InsuranceDataService.update(this.insurance_data.id, updateData)
          .then((response) => {
            this.message = response.message;

            this.onSaving = false;
          })
          .catch((e) => {
            console.log(e);
            this.message = e.message;
            this.showAlert("error");
          });
      }
    },

    deleteInsuranceData() {
      this.deleteLoading = true;
      InsuranceDataService.delete(this.insurance_data.id)
        .then((response) => {
          //console.log(response.data);
          this.message = response.message;
          this.deleteLoading = false;
          this.closeDeleteDialog();
          this.$router.push({ name: "insurancedata-list" });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    toList() {
      this.$router.push({ name: "insurancedata-list" });
    },
    toNew() {
      this.$router.push({ name: "add-insurancedata" });
    },
    handleCityChange(v) {
      //console.log('handleCityChange, v=')
      //console.log(v)
      if (v === null) {
        //console.log('handleCityChange, v === null')
        this.city = { name: null, areas: [] };
        //設定Model.city
        this.insurance_data.holder.city = "";
        this.insurance_data.holder.township = "";
        this.insurance_data.holder.zipcode = "";
      } else {
        this.city = v;
        //console.log('handleCityChange, city.name=' + this.city.name)
        //設定Model.city
        this.insurance_data.holder.city = this.city.name;

        //console.log('handleCityChange, city.areas=')
        //console.log(this.city.areas)
      }

      if (this.isHolderChanged == true) {
        this.isHolderChanged = false;
      } else {
        //因為城市變更了，所以要清空已選的區域
        this.township = { name: null, zip: null };
      }
    },
    openDeleteDialog() {
      this.deleteDialog = true;
    },
    //關閉對話框
    closeDeleteDialog() {
      this.deleteDialog = false;
    },
    //提示錯誤
    showAlert(type) {
      this.type = type;
      let timer = this.showAlert.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null;
      }, 3000);

      this.elapse = 1;
      let t = this.showAlert.t;
      if (t) {
        clearInterval(t);
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse++;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.edit-form {
  max-width: 300px;
  margin: auto;
}
</style>
